/* src/app/shared/components/add-new-company-dialog/autocomplete.helper.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
::ng-deep .autocomplete-wrapper {
  border-radius: 8px;
  width: 100%;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
}
::ng-deep .autocomplete-results {
  font-family:
    "Inter",
    Arial,
    sans-serif,
    sans-serif !important;
  background: white;
  width: 100%;
  font-family: "Roboto", sans-serif;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #E7ECF1;
}
::ng-deep .manual-entry {
  padding: 4px 24px 4px 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::ng-deep .manual-entry button mat-icon {
  width: 24px !important;
  height: 24px !important;
  font-size: 22px !important;
}
::ng-deep .manual-entry button {
  background: transparent !important;
  color: #006BB6 !important;
}
::ng-deep .manual-entry button:disabled {
  color: red;
  opacity: 0.5;
  background: transparent !important;
  color: #006BB6 !important;
}
::ng-deep .manual-entry span {
  font-weight: 600;
}
@media (max-height: 1200px) {
  .autocomplete-results {
    max-height: 30vh;
  }
}
@media (max-height: 900px) {
  .autocomplete-results {
    max-height: 20vh;
  }
}
@media (max-height: 700px) {
  .autocomplete-results {
    max-height: 15vh;
  }
}
@media (max-height: 400px) {
  .autocomplete-results {
    max-height: 10vh;
  }
}

/* src/app/shared/components/add-new-company-dialog/add-new-company-address-autocomplete/add-new-company-address-autocomplete.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
:host {
  display: block;
}
::ng-deep .autocomplete-wrapper .autocomplete-results .address-row {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  box-sizing: border-box;
  border: 2px solid transparent;
}
::ng-deep .autocomplete-wrapper .autocomplete-results .address-row:hover {
  background: #E7ECF1;
  cursor: pointer;
}
::ng-deep .autocomplete-wrapper .autocomplete-results .address-row:focus,
::ng-deep .autocomplete-wrapper .autocomplete-results .address-row:active {
  border: 2px solid #00529C;
  background: #E7ECF1;
}
::ng-deep .autocomplete-wrapper .autocomplete-results .address-row mat-icon {
  font-size: 18px;
  margin-right: 4px;
}
/*# sourceMappingURL=add-new-company-address-autocomplete.component.css.map */
